import { Link } from "react-router-dom";
import {
  EMA_LOGO, PHOBOS_LOGO, PHOBOS_TEXT, TYPHOON_LOGO, TYPHOON_TEXT,
  KPL_LOGO, FCN_LOGO, FCN_TEXT_LOGO
} from "@/constants";

export const EmaSection = () => (
  <section className="ema-section" data-testid="ema-section">
    <div className="company-block" data-testid="ema-block">
      <div className="logo-container" data-testid="ema-logo-container">
        <img src={EMA_LOGO} alt="EMA" className="ema-combined-logo logo-hover-target" data-testid="ema-logo" />
      </div>
      <p className="since-text">Since 2013</p>
    </div>
  </section>
);

export const PhobosTyphoonSection = () => (
  <section className="dual-section" data-testid="dual-section-pt">
    <div className="company-block" data-testid="phobos-block">
      <div className="logo-container" data-testid="phobos-logo-container">
        <img src={PHOBOS_LOGO} alt="Phobos Resources" className="company-logo phobos-logo logo-hover-target" data-testid="phobos-logo" />
      </div>
      <div className="phobos-text-container">
        <img src={PHOBOS_TEXT} alt="Phobos Resources" className="phobos-text-logo logo-hover-target" data-testid="phobos-text" />
      </div>
      <p className="since-text">Since 2017</p>
    </div>
    <div className="company-block" data-testid="typhoon-block">
      <div className="logo-container" data-testid="typhoon-logo-container">
        <Link to="/typhoon" className="logo-link" data-testid="typhoon-logo-link">
          <img src={TYPHOON_LOGO} alt="Typhoon Sports Group" className="company-logo typhoon-logo logo-hover-target" data-testid="typhoon-logo" />
        </Link>
      </div>
      <div className="typhoon-text-container">
        <Link to="/typhoon" className="logo-link" data-testid="typhoon-text-link">
          <img src={TYPHOON_TEXT} alt="Typhoon Sports Group" className="typhoon-text-logo logo-hover-target" data-testid="typhoon-text" />
        </Link>
      </div>
      <p className="since-text">Since 2024</p>
    </div>
  </section>
);

export const KplFcnSection = () => (
  <section className="dual-section" data-testid="dual-section-sports">
    <div className="company-block" data-testid="kpl-block">
      <div className="logo-container" data-testid="kpl-logo-container">
        <a
          href="https://www.kenyapremierleague.com/"
          target="_blank"
          rel="noreferrer"
          className="logo-link"
          data-testid="kpl-logo-link"
        >
          <img src={KPL_LOGO} alt="Kenya Premier League" className="company-logo kpl-logo logo-hover-target" data-testid="kpl-logo" />
        </a>
      </div>
      <p className="company-name kpl-name" data-testid="kpl-name">
        Kenya<br />Premier<br />League
      </p>
      <p className="since-text">Since 2004</p>
    </div>
    <div className="company-block" data-testid="fcn-block">
      <div className="logo-container" data-testid="fcn-logo-container">
        <a
          href="https://www.fcnairobi.com/"
          target="_blank"
          rel="noreferrer"
          className="logo-link"
          data-testid="fcn-logo-link"
        >
          <img src={FCN_LOGO} alt="FC Nairobi" className="company-logo fcn-logo logo-hover-target" data-testid="fcn-logo" />
        </a>
      </div>
      <div className="fcn-text-container" data-testid="fcn-text-container">
        <a
          href="https://www.fcnairobi.com/"
          target="_blank"
          rel="noreferrer"
          className="logo-link"
          data-testid="fcn-text-link"
        >
          <img src={FCN_TEXT_LOGO} alt="fc nairobi" className="fcn-text-logo logo-hover-target" data-testid="fcn-text" />
        </a>
      </div>
      <p className="since-text">Since 2026</p>
    </div>
  </section>
);
